import React from "react";
import { Button as ButtonComponent, Spinner } from "react-bootstrap";
import { KitchenButtonProps } from "./Button.props";
import "./style.scss";

const Button = React.memo<KitchenButtonProps>(
    ({
        btnText,
        className,
        handleClick,
        loading,
        disabled,
        children,
        btnIcon,
        ...props
    }) => {
        return (
            <ButtonComponent
                className={`kitchen-btn ${className}`}
                onClick={handleClick}
                variant="link"
                disabled={disabled || loading}
                data-testid="Button"
                {...props}
            >
                {loading && (
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        data-testid="Button__spinner"
                    />
                )}
                {btnIcon && btnIcon}
                {btnText ? btnText : ""}
                {children}
            </ButtonComponent>
        );
    }
);

export default Button;
